// extracted by mini-css-extract-plugin
export default {"root":"htmRILht","close":"grB7E08E","links":"AB2tNJvM","link":"VBjWJoMQ"};